export default {
	selected: {}
};



// WEBPACK FOOTER //
// ./sources/domains/school/class-level/state.js